import { Injectable } from '@angular/core';
import { UrlHelper } from "../../classes/urlHelper";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductLinkService {
  constructor(private httpClient: HttpClient) {
  }

  queryProductLinks(query: any) {
    return this.httpClient.get<any>('api/ProductLink/Query' + new UrlHelper().parseToUrlParams(query, 'query.'));
  }

  getProductLink(id: string) {
    return this.httpClient.get<any>('api/ProductLink/GetProductLink?id=' + encodeURIComponent(id));
  }

  saveProductLink(productLink: any) {
    return this.httpClient.post<any>('api/ProductLink/SaveProductLink', productLink);
  }

  deleteProductLink(id: string) {
    return this.httpClient.post<any>('api/ProductLink/DeleteProductLink', { Id: id });
  }

  updateCrawlerData(request: any) {
    return this.httpClient.post<any>('api/ProductLink/UpdateCrawlerData', request);
  }
}
